import { useEffect, useState } from "react";
import { SmarticoButtonDataModel } from "./types";

const MAX_RETRIES = 5;
let CURRENT_RETRY = 1;

const FunCentreSectionHeader = ({ smarticoData }: { smarticoData: SmarticoButtonDataModel }) => {
  const [avatarUrl, setAvatarUrl] = useState("/assets/images/menu/more-fun/fun-centre.png");

  useEffect(() => {
    const onEffectLoad = () => {
      if (CURRENT_RETRY >= MAX_RETRIES) {
        return;
      }
      CURRENT_RETRY++;
      if (!window._smartico || !window?._smartico?.api) {
        setTimeout(onEffectLoad, 1000);
        return;
      }
      updateValueFromSmartico();
      window._smartico.on("props_change", function (props: any) {
        updateValueFromSmartico(props);
      });
    };
    onEffectLoad();
    return () => {
      if (window._smartico) {
        window._smartico.off("props_change");
      }
    };
  }, []);

  const updateValueFromSmartico = (userProfile?: any) => {
    if (!userProfile) {
      userProfile = window._smartico.api.getUserProfile();
    }
    try {
      if (userProfile) {
        if (
          (userProfile.avatar_url && userProfile.avatar_url.length > 0) ||
          (userProfile.avatar_id && userProfile.avatar_id.length > 0)
        ) {
          setAvatarUrl(userProfile.avatar_url || userProfile.avatar_id);
        }

        // Unread messages
        const unreadMessages = userProfile.core_inbox_unread_count;
        if (unreadMessages && unreadMessages > 0) {
          const circleElement = document.querySelector(".fun-centre-container .fun-centre-circle");
          if (circleElement) {
            circleElement.innerHTML = String(unreadMessages);
            circleElement.classList.add("active");
          }
        }
      }
    } catch (ex) {
      console.error(ex);
    }
  };

  const onFunCentreClick = () => {
    window._smartico.dp("dp:gf");
  };

  if (smarticoData === null) {
    return;
  }

  return (
    <button
      type="button"
      onClick={onFunCentreClick}
      className="flex items-center w-full lg:w-[204px] h-[68px] pl-6 lg:pl-3 pr-4 gap-4 bg-gradient-to-r from-[#FCAC44] via-[#FE2E2D] to-[#9630D4] rounded-lg cursor-pointer">
      <div className="size-14 shrink-0 overflow-hidden">
        <img src={avatarUrl} alt="" width={56} height={56} className="object-cover size-full" />
      </div>
      <div className="font-jost text-base font-bold text-white leading-6 uppercase">FUN CENTRE</div>
      <div
        className={
          "flex items-center justify-center ml-auto uppercase bg-[#EEEEEF]/30 rounded-lg text-white font-jost text-xs font-medium w-14 h-8 lg:hidden"
        }>
        Enter
      </div>
    </button>
  );
};

export default FunCentreSectionHeader;
